import WorkspaceModel from '../models/WorkspaceModel';

export default class WorkspaceCollection extends Backbone.Collection {
  constructor(options) {
    super(options);

    this.model = WorkspaceModel;
  }

  url() {
    return `${appConstants.ApiPaths.WORKSPACE_REGISTRY_BASE_URL}/${appConstants.EndPoints.WORKSPACES_PATH}`;
  }

  dispatchCallback(payload) {
    const { actionType } = payload;
    const { ActionTypes } = appConstants;

    switch (actionType) {
      case ActionTypes.LOOKUP_WORKSPACE:
        // Build Basic Auth header for registry
        const clientId = window.EmployeeWeb.ENVConfig.workspace_registry_client_id || '';
        const clientSecret = window.EmployeeWeb.ENVConfig.workspace_registry_client_secret || '';
        const basicAuth = btoa(`${clientId}:${clientSecret}`);

        // Try registry first, fall back to local API if unavailable (development only)
        WorkspaceStore.fetch({
          url: `${appConstants.ApiPaths.WORKSPACE_REGISTRY_BASE_URL}/${appConstants.EndPoints.WORKSPACES_PATH}`,
          type: 'GET',
          dataType: 'json',
          data: payload.postData,
          headers: {
            Authorization: `Basic ${basicAuth}`,
          },
          success: WorkspaceStore.onWorkspaceLookupSuccess,
          error: (collection, error) => {
            // In development, if registry is unavailable (network error, 5xx), try local API fallback
            const isDevelopment = process.env.NODE_ENV === 'development';
            if (isDevelopment && (error.status === 0 || error.status >= 500)) {
              WorkspaceStore.fetch({
                url: `${appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV}${appConstants.ApiPaths.API_VERSION_PATH}${appConstants.EndPoints.WORKSPACES_PATH}`,
                type: 'GET',
                dataType: 'json',
                data: payload.postData,
                success: WorkspaceStore.onWorkspaceLookupSuccess,
                error: WorkspaceStore.onWorkspaceLookupError,
              });
            } else {
              WorkspaceStore.onWorkspaceLookupError(collection, error);
            }
          },
        });
        break;
      default:
        break;
    }
  }
}
